export const JOUR_TRAV_AN = 220;
export const NB_LITRE_KM = 0.08;
export const COUT_CARBU_LITRE = 1.7;
export const PRIX_LICENCE = 49;
export const COUT_PLAN_MOIS = 3000;
export function addThousandsSeparator(number)
{
    const numStr = number.toString();
    const parts = numStr.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join('.');
}

const CalculetteCommon = {
    simulationResultText: '',
    validateInputOnSubmit(input) {
        if (!!input.val().trim().length) {
            return true;
        }
        input.addClass('with-error');
        return false;
    },

    validateInputOnChange(input, form) {
        if (form.data('submit') === 'submitted') {
            if (input.val().trim().length > 0) {
                input.removeClass('with-error');
            } else {
                input.addClass('with-error');
            }
        }
    },
    
    displayValidResult(result1, result2, resultEltWrapper, resultFirstElt, resultSecondElt, resultZero, simulatorSection) {
        if (result1 > 0 || result2 > 0) {
            resultFirstElt.text(addThousandsSeparator(result1) + ' €');
            resultSecondElt.text(addThousandsSeparator(result2) + ' €*');
            resultZero.css('display', 'none');
            resultEltWrapper.css('display', 'flex');
            CalculetteCommon.simulationResultText = `${resultFirstElt.text()} à ${resultSecondElt.text()}`;
        } else {
            resultZero.css('display', 'block');
            resultEltWrapper.css('display', 'none');
            CalculetteCommon.simulationResultText = resultZero.text();
        }

        if (screen.width < 768) {
            $('html, body').animate(
                {
                    scrollTop: simulatorSection.offset().top - parseFloat($('#main_content').css('margin-top')),
                }, 500
            );
        }
    },

    alterSubmitButtonAppearance(calculetteForm) {
        const submitFormButton = calculetteForm.find('.cta');
        if (screen.width < 768) {
            if (!submitFormButton.hasClass('cta_fond_rouge')) {
                submitFormButton.addClass('cta_fond_rouge');
                submitFormButton.removeClass('cta_fond_transparent');
            }
        } else if (!submitFormButton.hasClass('cta_fond_transparent')) {
            submitFormButton.addClass('cta_fond_transparent');
            submitFormButton.removeClass('cta_fond_rouge');
        }
    },

    handleFocusInput(calculetteForm) {
        const formInputs = calculetteForm.find('.form-input');
        formInputs.each(
            function () {
                $(this).data('placeholder', this.placeholder);

                $(this).bind(
                    'focus', function () {
                        this.placeholder = '';
                    }
                );
                $(this).bind(
                    'blur', function () {
                        this.placeholder = $(this).data('placeholder');
                    }
                );
            }
        );
    },
};

export default CalculetteCommon;
